export function getCategories(): string[] {
  return [
    "Developpement Web",
    "Data Science",
    "Design",
    "Marketing Digital",
    "Business",
    "Langues",
    "Productivite",
    "Autre",
  ];
}
